import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hospital", "doctor", "doctorSection"]
  static values = { initialDoctorId: String }

  async connect() {
    // Dynamically import TomSelect only when this controller is connected
    const module = await import("../vendors/tom-select.js");
    const TomSelect = module.default || module;
    if (!TomSelect) {
      console.error("TomSelect not loaded");
      return;
    }
    this.TomSelect = TomSelect;
    this.initTomSelect();

    const modal = this.element.closest(".modal");
    if (modal) {
      modal.addEventListener("show.bs.modal", (event) => {
        const button = event.relatedTarget;
        if (!button) return;

        const selectedHospitalId = button.getAttribute("data-hospital-id");
        const selectedDoctorId   = button.getAttribute("data-doctor-id");

        if (selectedHospitalId) {
          this.hospitalTarget.value = selectedHospitalId;
          this.initialDoctorIdValue = selectedDoctorId;
          this.loadDoctors();
        }
      });
    }

    if (this.hospitalTarget.value) {
      this.loadDoctors();
    }
  }

  initTomSelect() {
    this.ts = new this.TomSelect(this.doctorTarget, {
      valueField: "id",
      labelField: "name",
      searchField: ["name", "specialty"],
      placeholder: "Select Doctor",
      allowEmptyOption: false,
      closeAfterSelect: true,
      hideSelected: true,
      render: {
        option: (data, escape) => `
          <div style="display:flex;align-items:center;padding:10px 15px;">
            <img src="${escape(data.photo)}" style="width:48px;height:48px;margin-right:10px;object-fit:cover;" />
            <div style="display:flex;flex-direction:column;">
              <span style="font-weight:600;font-size:16px;margin-bottom:5px;">${escape(data.name)}</span>
              <span style="font-size:16px;color:#666;">${escape(data.specialty)} | ${escape(data.experience_years)} yrs</span>
            </div>
          </div>`,
        item: (data, escape) => `
          <div style="display:flex;align-items:center;">
            <img src="${escape(data.photo)}" style="width:48px;height:48px;margin-right:10px;object-fit:cover;" />
            <div style="display:flex;flex-direction:column;">
              <span style="font-weight:600;font-size:16px;margin-bottom:5px;">${escape(data.name)}</span>
              <span style="font-size:16px;color:#666;">${escape(data.specialty)} | ${escape(data.experience_years)} yrs</span>
            </div>
          </div>`
      }
    })
  }

  hospitalChanged() {
    this.loadDoctors()
  }

  loadDoctors() {
    const hid = this.hospitalTarget.value
    const section = this.doctorSectionTarget

    // Hide section immediately in the next animation frame
    requestAnimationFrame(() => section.style.display = "none")

    this.ts.clear(true)
    this.ts.clearOptions()

    if (!hid) return

    fetch(`/hospitals/${hid}/doctors`, { headers: { Accept: "application/json" } })
      .then(r => r.json())
      .then(doctors => {
        if (!doctors.length) return

        // Batch all DOM writes in requestAnimationFrame
        requestAnimationFrame(() => {
          section.style.display = "block"

          this.ts.addOptions(doctors.map(d => ({
            id: d.id,
            name: d.name,
            specialty: d.specialty,
            experience_years: d.experience_years,
            photo: d.photo_url
          })))

          this.ts.refreshOptions(false)

          if (this.initialDoctorIdValue) {
            this.ts.setValue(this.initialDoctorIdValue)
            this.initialDoctorIdValue = null
          }
        })
      })
      .catch(err => {
        console.error("Error loading doctors:", err)
        requestAnimationFrame(() => section.style.display = "none")
      })
  }
}
